export const CATEGORY_LABELS = {
  ordinary:    { label: 'Normal',     short: 'N',   color: '#6b7280' },
  overtime_1:  { label: 'Övertid 1',  short: 'OT1', color: '#f59e0b' },
  overtime_2:  { label: 'Övertid 2',  short: 'OT2', color: '#dc2626' },
  comp_earned: { label: 'Komp',       short: 'K',   color: '#7c3aed' },
  ob_evening:  { label: 'OB kväll',   short: 'OB1', color: '#0ea5e9' },
  ob_night:    { label: 'OB natt',    short: 'OB3', color: '#6366f1' },
  ob_weekend:  { label: 'OB helg',    short: 'OB2', color: '#ec4899' },
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORY_LABELS)
  .map(([value, { label }]) => ({ value, label }));

export const formatElapsed = (seconds, { showSeconds = true } = {}) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (!showSeconds) return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  const s = seconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};
